var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "1 0 511.999 511",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m471.601562 233.542969 39.96875-39.964844v258.824219c0 33.054687-26.894531 59.949218-59.953124 59.949218h-391.667969c-33.054688 0-59.949219-26.894531-59.949219-59.949218v-391.667969c0-33.058594 26.894531-59.949219 59.949219-59.949219h259.121093l-39.964843 39.964844h-219.15625c-11.019531 0-19.984375 8.964844-19.984375 19.984375v391.667969c0 11.019531 8.964844 19.984375 19.984375 19.984375h391.667969c11.019531 0 19.984374-8.964844 19.984374-19.984375zm-186.835937-117.855469c-97.519531 0-176.855469 79.28125-176.855469 176.734375 0 46.910156 22.65625 85.402344 41.660156 109.429687l31.347657-24.792968c-15.074219-19.058594-33.042969-49.210938-33.042969-84.636719 0-75.417969 61.410156-136.769531 136.890625-136.769531h151.683594l-88.835938 88.835937 28.261719 28.261719 136.125-136.125-136.125-136.125-28.261719 28.257812 86.929688 86.929688zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e41ee74a.svg";
export { ForwardRef as ReactComponent };